/* eslint-disable no-unused-vars */
import template from './search-criteria-group-item.html';

const DIRECTIVE_NAME = AtcSearchCriteriaGroupItem.DIRECTIVE_NAME = 'ktAtcSearchCriteriaGroupItem';
export default function AtcSearchCriteriaGroupItem() {
    return {
        restrict: 'A',
        template,
        bindToController: true,
        controller: AtcSearchCriteriaGroupItemController,
        controllerAs: '$ctrl',
        scope: {
            model: `=${DIRECTIVE_NAME}`,
            index: `=${DIRECTIVE_NAME}Index`,
            cabinClasses: `=${DIRECTIVE_NAME}CabinClasses`,
            prevSegment: `=${DIRECTIVE_NAME}PrevSegment`,
        },
        link: function($scope, $elem, $attrs, searchCriteriaGroupItemCtrl) {
            searchCriteriaGroupItemCtrl.$onInit();
        },
    };
}

export function AtcSearchCriteriaGroupItemController(
    $scope,
    userService,
    MOMENT,
    atcSearchCriteriaGroupItemService,
    timeService,
    atcFlightsService,
    l10nService,
    atcApiService,
) {
    'ngInject';

    const vm = this;
    const fromToPlaceholder = l10nService.localize('Airport...');
    let rsDateFormat;

    $scope.frequentFlights = [];

    Object.assign(vm, {
        fromToPlaceholder,
        $onInit,
        workingHoursRestriction: userService.getUser().WorkingHoursRestriction,
        getFrequentFlightView: atcSearchCriteriaGroupItemService.getFrequentFlightView,
        setSelectedFrequentFlight: atcSearchCriteriaGroupItemService.setSelectedFrequentFlight,
        isCurrentDay: atcFlightsService.isCurrentDay,
        getTypeaheadLocation,
        onChangeLocation,
    });

    function $onInit() {
        rsDateFormat = userService.getRegionalSettings().dateFormat;
        initDatePicker();
        watchPreviousDate();
        watchDateChange();
    }

    function watchPreviousDate() {
        if (vm.prevSegment) {
            $scope.$watch(() => vm.prevSegment.departureDate, () => {
                const {departureDate: previousDate} = vm.prevSegment;
                const prevSegmentDate = vm.prevSegment.departureDate;
                const currentSegmentDate = vm.model.TicketSearchSegments[vm.index].departureDate;
                if (previousDate) {
                    vm.pickerOptions.after = prevSegmentDate.subtract(1, 'days');
                    vm.pickerOptions.start = prevSegmentDate;
                }
                if (prevSegmentDate.isAfter(currentSegmentDate)) {
                    vm.model.TicketSearchSegments[vm.index].departureDate = null;
                }
            });
        }
    }

    function initDatePicker() {
        const {dateFormat} = userService.getRegionalSettings();
        vm.model.TicketSearchSegments[vm.index].DepartureDate = timeService.format(timeService.parseAtcApiFormat(vm.model.TicketSearchSegments[vm.index].DepartureDate));
        vm.model.TicketSearchSegments[vm.index].departureDate = timeService.parse(vm.model.TicketSearchSegments[vm.index].DepartureDate);
        vm.initDate = vm.model.TicketSearchSegments[vm.index].departureDate;
        vm.pickerOptions = {
            dateFormat,
            placeholder: l10nService.localize('Depart date'),
            required: true,
            months: 2,
            start: vm.initDate,
            after: moment().add({days: -1}),
            before: atcFlightsService.getMaxBookDate(),
        };
    }

    function watchDateChange() {
        //$scope.$watch(() => vm.model.TicketSearchSegments[vm.index].departureDate, recalculateTimeOptions);

        // function recalculateTimeOptions() {
        //     const {departureDate: date,
        //            _time: time} = vm.model.TicketSearchSegments[vm.index];
        //     const departDate = moment(date, rsDateFormat);
        //     const now = MOMENT.init();
        //     let minHour;

        //     if (departDate.isValid() && isSame()) {
        //         vm.filteredTimeOptions = _.filter(angular.copy(vm.timeOptions), (item) => item.startHour >= minHour);

        //         const departTime = time;
        //         if (!_.find(vm.filteredTimeOptions, departTime)) {
        //             Object.assign(time, vm.filteredTimeOptions[0]);
        //         }
        //     } else {
        //         vm.filteredTimeOptions = vm.timeOptions;
        //         Object.assign(time, vm.filteredTimeOptions[0]);
        //     }

        //     function isSame() {
        //         if (vm.index === 0) {
        //             minHour = now.hour();
        //             return departDate.isSame(now, 'day');
        //         }
        //             const prevDate = moment(vm.model.TicketSearchSegments[vm.index - 1].departureDate, rsDateFormat);
        //             minHour = vm.model.TicketSearchSegments[vm.index - 1]._time.startHour % 24;

        //             if (minHour === 0 && departDate.isSame(now, 'day')) {
        //                 minHour = now.hour();
        //             }

        //             return prevDate.isValid() && departDate.isSame(prevDate, 'day');

        //     }
        // }
    }

    function getTypeaheadLocation(searchPattern) {
        vm.airports = [];
        if (searchPattern && searchPattern.length < 2) {
            return vm.airports;
        }
        const params = {
            params: {searchPattern},
            noSpinner: true,
        };
        return atcApiService.searchLocation(params);
    }

    function onChangeLocation() {
        if (vm.model.TicketSearchSegments.length > 3
            || vm.model.TicketSearchSegments.filter((seg) => seg.DepartureAirport.length > 1).length !== 0
            || vm.model.TicketSearchSegments.filter((seg) => seg.ArrivalAirport.length > 1).length !== 0) {
            vm.model.FlexibleCondition = false;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/atc/atc-check-result/search-criteria-group-item/search-criteria-group-item-component.js